import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReferenceElement } from '@floating-ui/dom';
import { InfoPopoverComponent } from '../../../../shared/components/info-popover/info-popover.component';
import { ButtonComponent } from 'app/shared/components/button/button.component';
import { CheckboxInputComponent } from 'app/shared/components/checkbox-input/checkbox-input.component';
import { IbanInputComponent } from 'app/shared/components/iban-input/iban-input.component';

@Component({
  selector: 'ez-sepa-input-box',
  imports: [
    CheckboxInputComponent,
    ButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    IbanInputComponent,
    InfoPopoverComponent,
  ],
  templateUrl: './sepa-input-box.component.html',
  styleUrl: './sepa-input-box.component.scss',
})
export class SepaInputBoxComponent implements OnInit, AfterViewInit {
  private destroyRef = inject(DestroyRef);

  @ViewChild('sepaInfo') sepaInfoEl: ElementRef;
  @Output() backToOverview = new EventEmitter();
  @Output() submitForm = new EventEmitter();
  @Input() sepaFormGroup: FormGroup;
  @Input({ required: true }) creditorId: string;
  @Input({ required: true }) organisationName: string;
  anchor: ReferenceElement;
  popover: HTMLElement;
  showPopover: boolean;

  readonly errorMessage = signal<string | null>(null);

  ngOnInit(): void {
    this.showPopover = false;
    this.sepaFormGroup.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() =>
        this.errorMessage.set(
          this.sepaFormGroup.errors ? 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.' : null,
        ),
      );
  }

  ngAfterViewInit(): void {
    this.anchor = this.sepaInfoEl.nativeElement;
  }

  onBackToOverview() {
    this.backToOverview.emit();
  }

  onSubmit() {
    this.submitForm.emit();
  }
}
